import { LessonRecordOnlyCountDocument, ProjectRecordOnlyCountDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

/**
 * Record-only tally for a lesson or project, fetched only while `active` so listings don't pay for
 * a count nobody is looking at. Always refetched, since a bulk update doesn't touch the cached count.
 */
export function useRecordOnlyCount(
  type: "project" | "lesson" | "slide",
  id: string,
  active: boolean
) {
  const lesson = useQuery(LessonRecordOnlyCountDocument, {
    variables: { lessonId: id },
    skip: !active || type !== "lesson" || !id,
    fetchPolicy: "network-only",
  });

  const project = useQuery(ProjectRecordOnlyCountDocument, {
    variables: { projectId: id },
    skip: !active || type !== "project" || !id,
    fetchPolicy: "network-only",
  });

  const count =
    type === "lesson" ? lesson.data?.lessonRecordOnlyCount : project.data?.projectRecordOnlyCount;

  return { count: count ?? null, loading: lesson.loading || project.loading };
}
